import Button from '@/components/common/Button'

function WikiViewToggle({ viewMode, onViewModeChange }) {
  return (
    <div className="inline-flex rounded-lg border-2 border-border bg-white p-1">
      <button
        onClick={() => onViewModeChange('cards')}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          viewMode === 'cards'
            ? 'bg-brand-green text-white'
            : 'text-brand-charcoal hover:bg-brand-cream'
        }`}
      >
        <span className="mr-2">📇</span>
        Cards
      </button>
      <button
        onClick={() => onViewModeChange('document')}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          viewMode === 'document'
            ? 'bg-brand-green text-white'
            : 'text-brand-charcoal hover:bg-brand-cream'
        }`}
      >
        <span className="mr-2">📄</span>
        Document
      </button>
    </div>
  )
}

export default WikiViewToggle

